document.addEventListener('DOMContentLoaded', function () {
    function initCarousel() {
        const carousel = document.querySelector('.team-members-clinic');
        const dots = document.querySelectorAll('.dot-clinic');
        const teamMemberWidth = document.querySelector('.team-member-clinic').offsetWidth;
        let currentIndex = 0;

        dots.forEach((dot, index) => {
            dot.addEventListener('click', function () {
                currentIndex = index;
                updateCarousel();
            });
        });

        function updateCarousel() {
            const offset = -currentIndex * teamMemberWidth;
            carousel.style.transform = `translateX(${offset}px)`;
            dots.forEach(dot => dot.classList.remove('active'));
            dots[currentIndex].classList.add('active');
        }

        updateCarousel(); // Initialize the carousel
    }

    if (window.innerWidth <= 768) {
        initCarousel();
    }

    window.addEventListener('resize', function () {
        if (window.innerWidth <= 768) {
            initCarousel();
        }
    });
});